'use client'

import { memo } from 'react'
import { NinxlHeroDemoPlayer } from '@/app/ninxl/_components/ninxl-hero-demo-player'
import { useLandingHeroDemoSrc } from '@/lib/cms/use-landing-hero-demo-src'
import { NinOrgMissionScene } from './nin-org-mission-scene'

/** Play-demo strip: temple scene + hero demo dialog (CMS /nin platform video). */
export const NinOrgDemoSection = memo(function NinOrgDemoSection() {
  // baby: one fixed CMS video for /nin Play demo (not the feature carousel)
  const demoSrc = useLandingHeroDemoSrc('nin')

  return (
    <section
      data-section="demo"
      className="nin-org-demo-section relative z-20 py-12 md:py-16"
      aria-label="NIN hero demo"
    >
      <div className="mx-auto max-w-4xl px-6">
        <div className="ninxl-8bit-label ninxl-theme-text-accent mb-6 text-center tracking-[0.2em]">
          WATCH THE SANCTUARY
        </div>
        <div className="ninxl-pixel-border ninxl-theme-bg-frame relative overflow-hidden">
          <div className="relative aspect-[16/9] w-full min-h-[220px] md:min-h-[360px]">
            <NinOrgMissionScene />
            <div className="ninxl-crt-overlay pointer-events-none absolute inset-0" />
            <NinxlHeroDemoPlayer
              variant="8bit"
              className="ninxl-hero-demo-on-monitor"
              demoSrc={demoSrc}
              ariaLabel="Play NIN hero demo"
              dialogTitle="NIN sanctuary demo"
            />
          </div>
        </div>
      </div>
    </section>
  )
})